// Single source of app-level (tenant-agnostic) configuration.
// Static hosting has no server build, so these values are baked into the
// committed bundle — the point is ONE place to change, not secrecy (the anon
// key is public by design; isolation is enforced by RLS).
export const CONFIG = {
  supabaseUrl: 'https://rzbqqssscfilknnmralc.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ6YnFxc3NzY2ZpbGtubm1yYWxjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQyNDg4NTIsImV4cCI6MjA5OTgyNDg1Mn0.GH_lmftWio9WVnE1QH3OfI0jAdD06Tm9n2KL7oCGEck',
  appName: 'Ordinex',
  appUrl: 'https://app.ordinex.ca',
};
